import { useT } from '@/i18n';

/** Keyboard users land here first; hidden until focused. */
export function SkipLink() {
  const t = useT();
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-accent focus:px-4 focus:py-2 focus:text-accent-ink"
    >
      {t('common.skipToContent')}
    </a>
  );
}
